import * as React from 'react';
import { Header } from 'semantic-ui-react';

import { Datos as PendienteDatos } from '../../../componentes/Pendiente';

export interface Datos {
    pendiente: PendienteDatos;
}

export const inicial: Datos = {
    pendiente: { pendiente: false, fechaCompromiso: '' },
};

interface Props {}

class Contado extends React.Component<Props, {}> {
    public render() {
        return (
            <div>
                <Header as='h3'>Contado</Header>
            </div>
        );
    }
}

export default Contado;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/Contado.tsx